import { ArrayFilterInput } from "./inputs/ArrayFilterInput";
import { BooleanFilterInput } from "./inputs/BooleanFilterInput";
import { LocationFilterInput } from "./inputs/LocationFilterInput";
import { NearMeFilterInput } from "./inputs/NearMeFilterInput";
import { PresetFilterInput } from "./inputs/PresetFilterInput";
import { RadioFilterInput } from "./inputs/RadioFilterInput";
import { SearchFilterInput } from "./inputs/SearchFilterInput";
import { StringFilterInput } from "./inputs/StringFilterInput";
import type { FilterConfiguration } from "./types";

interface FilterProps {
  configuration: FilterConfiguration;
}

export const Filter = ({ configuration }: FilterProps) => {
  if (!configuration.enabled) {
    return null;
  }

  switch (configuration.input_type) {
    case "search":
      return <SearchFilterInput configuration={configuration} />;
    case "string":
      return <StringFilterInput configuration={configuration} />;
    case "boolean":
      return <BooleanFilterInput configuration={configuration} />;
    case "radio":
      return <RadioFilterInput configuration={configuration} />;
    case "array":
      return <ArrayFilterInput configuration={configuration} />;
    case "near_me":
      return <NearMeFilterInput configuration={configuration} />;
    case "preset":
      return <PresetFilterInput configuration={configuration} />;
    case "location":
      return <LocationFilterInput configuration={configuration} />;
    default:
      return null;
  }
};
